module.exports = __webpack_public_path__ + "img/3.0a2c650f.jpg";